import BarChartsHorizontal from "../../../Components/Charts/BarChartsHorizontalLeadSource.js";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service.jsx";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

// Function to handle API calls with different body inputs
const state_wise = async (body, endpoint) => {
  try {
    const res = await axInst.post(endpoint, body);
    const buckets = res.data.Retail;

    const keyData = buckets.map((bucket) => bucket.key);
    const valData = buckets.map((bucket) => bucket.value);

    return {
      keyData,
      valData,
    };
  } catch (error) {
    console.error(error);
  }
};

export const RetailCharts = () => {
  const { data, submitted } = useSelector((e) => e.filtersLeadSource);

  // Use different API endpoints or payloads for each query
  const {
    data: statewise1,
    isFetching: fetching1,
    isError: error1,
  } = useQuery({
    queryKey: ["statewise1", submitted],
    queryFn: () => state_wise(data, "lead-source/lead_beat_graph"),
    // refetchInterval: 300000,
    // refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: statewise2,
    isFetching: fetching2,
    isError: error2,
  } = useQuery({
    queryKey: ["statewise2", submitted],
    queryFn: () => state_wise(data, "lead-source/lead_btl_graph"),
    // refetchInterval: 300000,
    // refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: statewise3,
    isFetching: fetching3,
    isError: error3,
  } = useQuery({
    queryKey: ["statewise3", submitted],
    queryFn: () => state_wise(data, "lead-source/lead_digital_graph"),
    // refetchInterval: 300000,
    // refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: statewise4,
    isFetching: fetching4,
    isError: error4,
  } = useQuery({
    queryKey: ["statewise4", submitted],
    queryFn: () => state_wise(data, "lead-source/lead_tgm_graph"),
    // refetchInterval: 300000,
    // refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: statewise5,
    isFetching: fetching5,
    isError: error5,
  } = useQuery({
    queryKey: ["statewise5", submitted],
    queryFn: () => state_wise(data, "lead-source/lead_atl_graph"),
    // refetchInterval: 300000,
    // refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className="relative">
      {(fetching1 || fetching2 || fetching3 || fetching4 || fetching5) && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {(error1 || error2 || error3 || error4 || error5) && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-5">
        {!fetching1 && !error1 && (
          <div className="bg-white rounded-md p-2 relative">
            <WaterMark />
            <BarChartsHorizontal
              data={statewise1}
              heading={"Beat Plan Retail"}
              h={"175px"}
              p={"inside"}
              color={["#bae3f7", "#49b1e5"]}
            />
          </div>
        )}

        {!fetching2 && !error2 && (
          <div className="bg-white rounded-md p-2 relative">
            <WaterMark />
            <BarChartsHorizontal
              data={statewise2}
              heading={"BTL Retail"}
              h={"170px"}
              p={"inside"}
              color={["#e8cb89", "#FAC858"]}
            />
          </div>
        )}
        {!fetching3 && !error3 && (
          <div className="bg-white rounded-md p-2 relative">
            <WaterMark />
            <BarChartsHorizontal
              data={statewise3}
              heading={"Digital Retail"}
              h={"170px"}
              p={"inside"}
              color={["#e6b89a", "#ee9c66"]}
            />
          </div>
        )}
        {!fetching5 && !error5 && (
          <div className="bg-white rounded-md p-2 relative">
            <WaterMark />
            <BarChartsHorizontal
              data={statewise5}
              heading={"ATL Retail"}
              h={"170px"}
              p={"inside"}
              color={["#faa7fa", "#f74af7"]}
            />
          </div>
        )}
        {!fetching4 && !error4 && (
          <div className="bg-white rounded-md p-2 relative">
            <WaterMark />
            <BarChartsHorizontal
              data={statewise4}
              heading={"TGM Retail"}
              h={"170px"}
              p={"inside"}
              color={["#afe895", "#91CC75"]}
            />
          </div>
        )}
      </div>
    </div>
  );
};
